"use client"

import * as React from "react"
import { format } from "date-fns"
import { CalendarIcon } from "lucide-react"
import { DateRange } from "react-day-picker"

import { cn } from "@/lib/utils"
import { Calendar } from "@/Components/ui/calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/Components/ui/popover"
import { dateformat } from "@/utils/GlobalConstants"


interface DateRangePickerProps {
  description: string,
  className?: string,
  setDate: React.Dispatch<React.SetStateAction<DateRange | undefined>>
  date?: DateRange | undefined
}

export function DateRangePicker({ className, date, setDate, description }: DateRangePickerProps) {

  function updatedDateRange(date: DateRange | undefined) {
    if (!date) return

    setDate(() => { return date; })

  }

  return (
    <div className={cn("grid gap-2", className)}>
      <Popover>
        <PopoverTrigger asChild>
          <button
            id="date"
            className={cn(
              "flex flex-row w-[165px] h-[21px] justify-start items-center font-normal bg-gray-200 text-gray-600 border border-gray-200 rounded-sm",
              !date && "text-muted"
            )}
          >
            <CalendarIcon className="w-4 mx-1" />
            {date?.from ? (
              date.to ? (
                <>
                  {format(date.from, dateformat)} -{" "}
                  {format(date.to, dateformat)}
                </>
              ) : (
                format(date.from, dateformat)
              )
            ) : (
              <span>{description}</span>
            )}
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={date?.from}
            selected={date}
            onSelect={updatedDateRange}
            numberOfMonths={2}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}